import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { LocalizationSelectors } from '@serviceos-ng/core';
import {
    expandOnEnterAnimation,
    collapseOnLeaveAnimation,
} from 'angular-animations';
@Component({
    selector: 'serviceos-web-benefits-list',
    templateUrl: './benefits-list.component.html',
    styleUrls: ['./benefits-list.component.scss'],
    animations: [expandOnEnterAnimation(), collapseOnLeaveAnimation()],
})
export class BenefitsListComponent implements OnInit {
    @Input()
    benefits: { icon_url: string; title: string }[] = [];

    @Input()
    texts = {
        expand: 'expand',
        expanded: 'expanded',
    };

    public expanded = false;
    public documentDirection = '';

    constructor(
        private store: Store
    ) {

    }

    ngOnInit(): void {
        this.store.select(LocalizationSelectors.getCurrentDirection()).subscribe(
            (currentDirection) => {
                if (currentDirection) {
                    this.documentDirection = currentDirection;
                }
            }
        )
    }
}
